export default class UsidxTrendService {
  getAll() {
    return fetch("https://api.tradersr.com/api/usidxtrend")
      .then(res => res.json());
  }
}